import { render } from "./FocusGroup.vue?vue&type=template&id=45682054&scoped=true"
import script from "./FocusGroup.vue?vue&type=script&lang=js"
export * from "./FocusGroup.vue?vue&type=script&lang=js"

import "./FocusGroup.vue?vue&type=style&index=0&id=45682054&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45682054"]])

export default __exports__